import Icons from "../../assets/icon";

import {
  HoverButton,
  DashboardHeading,
  FormInput,
  PrefilledDropDown,
  SidenavbarCom,
  SearchbarCom,
  Textarea,
} from "../../components";
import Functions from "./index.function";
function UpdateJob() {
  const {
    handleSubmit,
    control,
    errors,
    isLoading,
    jobListing,
    isLoadingprefilled,
    setValue,
    register,
    setSelectedOption,
    selectedOption,
    onSubmit,
    dropdowns,
    jobDropdowns,
    prefiledjobDropdowns,
    states,
    isLoadingStates,
    cities,
    prefiledCitiesDropdowns,
    loadingToapi,
  } = Functions();
  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 scroll-container h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 pt-2 pb-1 h-full`}>
            <form
              className="flex flex-col relative w-full bg-[#1A1A1A]  xs:px-2 sm:px-5 lg:px-10 rounded-lg h-full"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="py-5 sm:py-10">
                <DashboardHeading title={"Update Job"} />
              </div>
              <div className="flex-1 overflow-y-auto scroll-container">
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Job Title"}
                      control={control}
                      userData={jobListing}
                      name="title"
                      type="text"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label="Jobs Type"
                      options={jobDropdowns?.job_type}
                      valueName="job_type"
                      valueoption="job_type_id"
                      name="job_type_id"
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label="Country"
                      options={dropdowns?.country || []}
                      valueName="country"
                      valueoption="country_id"
                      name="countries"
                      isLoadingpreFiled={isLoadingprefilled}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"Province / State"}
                      options={states}
                      valueName="state"
                      valueoption="state_id"
                      name={"state_id"}
                      isLoadingpreFiled={isLoadingStates}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"City"}
                      options={cities}
                      valueName="city"
                      valueoption="city_id"
                      name={"city_id"}
                      isLoadingpreFiled={prefiledCitiesDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Post Code"}
                      control={control}
                      userData={jobListing}
                      name="postal_code"
                      type="text"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className="w-full px-[2px]">
                  <div className="w-full lg:pt-5">
                    <Textarea
                      lable={"Description"}
                      name={"description"}
                      register={register}
                      setValue={setValue}
                      errors={errors}
                      isMandatory={true}
                    />
                  </div>
                  <div className="w-full lg:pt-5">
                    <Textarea
                      lable={"Benefits"}
                      name={"benefits"}
                      register={register}
                      setValue={setValue}
                      errors={errors}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"Job Shift"}
                      options={jobDropdowns?.job_shift}
                      valueName="job_shift"
                      valueoption="job_shift_id"
                      name={"job_shift_id"}
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      isRequired={true}
                      rightIcon={Icons.arrowIcon}
                      label={"Gender"}
                      options={dropdowns?.gender}
                      valueName="gender"
                      valueoption="id"
                      name={"gender"}
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Expiry Date"}
                      control={control}
                      userData={jobListing}
                      name="expiry_date"
                      type="date"
                      cardIcon={Icons.calendarIcon}
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"Degree Level"}
                      options={jobDropdowns?.degree_level}
                      valueName="degree_level"
                      valueoption="degree_level_id"
                      name={"degree_level_id"}
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"Job Experience"}
                      options={jobDropdowns?.job_experience}
                      valueName="job_experience"
                      valueoption="job_experience_id"
                      name={"job_experience_id"}
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <PrefilledDropDown
                      control={control}
                      errors={errors}
                      rightIcon={Icons.arrowIcon}
                      label={"Salary Period"}
                      options={jobDropdowns?.salary_period}
                      valueName="salary_period"
                      valueoption="salary_period_id"
                      name={"salary_period_id"}
                      isLoadingpreFiled={prefiledjobDropdowns}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Salary From"}
                      control={control}
                      userData={jobListing}
                      name="salary_from"
                      type="number"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Salary To"}
                      control={control}
                      userData={jobListing}
                      name="salary_to"
                      type="number"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div
                  className={
                    "flex xs:flex-col items-end w-full sm:gap-2 lg:gap-4"
                  }
                >
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <FormInput
                      label={"Number Of Positions"}
                      control={control}
                      userData={jobListing}
                      name="num_of_positions"
                      type="number"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className="flex justify-start flex-wrap gap-x-3 gap-y-4 items-center w-full lg:pb-4 mt-[18px]">
                  {/* Freelance */}
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      id="is_freelance"
                      name="is_freelance"
                      className="custom-checkbox"
                      checked={selectedOption.is_freelance === 1}
                      onChange={(e) =>
                        setSelectedOption((prev) => ({
                          ...prev,
                          is_freelance: e.target.checked ? 1 : 0,
                        }))
                      }
                    />
                    <label
                      htmlFor="is_freelance"
                      className="text-[#808080] ml-2 cursor-pointer"
                    >
                      Freelance
                    </label>
                  </div>

                  {/* Show Salary */}
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      id="hide_salary"
                      name="hide_salary"
                      className="custom-checkbox"
                      checked={selectedOption.hide_salary === 0}
                      onChange={(e) =>
                        setSelectedOption((prev) => ({
                          ...prev,
                          hide_salary: e.target.checked ? 0 : 1,
                        }))
                      }
                    />
                    <label
                      htmlFor="hide_salary"
                      className="text-[#808080] ml-2 cursor-pointer"
                    >
                      Show Salary
                    </label>
                  </div>

                  {/* Active */}
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      id="is_active"
                      name="is_active"
                      className="custom-checkbox"
                      checked={selectedOption.is_active === 1}
                      onChange={(e) =>
                        setSelectedOption((prev) => ({
                          ...prev,
                          is_active: e.target.checked ? 1 : null, // null when unchecked
                        }))
                      }
                    />
                    <label
                      htmlFor="is_active"
                      className="text-[#808080] ml-2 cursor-pointer"
                    >
                      Active
                    </label>
                  </div>
                  {/* Featured */}
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      id="is_featured"
                      name="is_featured"
                      className="custom-checkbox"
                      checked={selectedOption.is_featured === 1}
                      onChange={(e) =>
                        setSelectedOption((prev) => ({
                          ...prev,
                          is_featured: e.target.checked ? 1 : 0,
                        }))
                      }
                    />
                    <label
                      htmlFor="is_featured"
                      className="text-[#808080] ml-2 cursor-pointer"
                    >
                      Featured
                    </label>
                  </div>

                  {/* Inactive */}
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      id="is_inactive"
                      name="is_inactive"
                      className="custom-checkbox"
                      checked={selectedOption.is_active === 0}
                      onChange={(e) =>
                        setSelectedOption((prev) => ({
                          ...prev,
                          is_active: e.target.checked ? 0 : null, // null when unchecked
                        }))
                      }
                    />
                    <label
                      htmlFor="is_inactive"
                      className="text-[#808080] ml-2 cursor-pointer"
                    >
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-center flex-col items-center pt-2.5 sm:pt-5 pb-5 sm:pb-10">
                <HoverButton
                  extraClasses={
                    "group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle={
                    loadingToapi ? (
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                      </div>
                    ) : (
                      "Submit"
                    )
                  }
                  type={"submit"}
                  BtnTitleClasses={
                    "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateJob;
